/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/* eslint-disable import/no-unresolved, import/default */

import activationLinkDialogTemplate from './activation-link.dialog.tpl.html';
import addUserTemplate from './add-user.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function UserTableConfig($q, $translate, $mdDialog, $document, toast, types, utils, userService,
                                        providerService, customerService, subCustomerService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(params) {

        var deferred = $q.defer();

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;

        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        var titleEntityPromise;

        if (params.providerId) {
            scope = types.scope.provider;
            titleEntityPromise = providerService.getProvider(params.providerId);
        } else if (params.customerId) {
            scope = types.scope.customer;
            titleEntityPromise = customerService.getCustomer(params.customerId);
        } else if (params.subCustomerId) {
            scope = types.scope.subCustomer;
            titleEntityPromise = subCustomerService.getSubCustomer(params.subCustomerId);
        }

        if (titleEntityPromise) {
            titleEntityPromise.then(
                (titleEntity) => {
                    var tableConfiguration = createUserConfig(scope, access, params, titleEntity.title);
                    deferred.resolve(tableConfiguration);
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            var tableConfiguration = createUserConfig(scope, access, params);
            deferred.resolve(tableConfiguration);
        }
        return deferred.promise;
    }

    function createUserConfig(scope, access, params, entityTitle) {

        var currentUser = userService.getCurrentUser();

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.user,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                { key: 'createdTime',
                    title: 'entity.createdTime'},
                { key: 'email',
                    title: 'user.email'},
                { key: 'firstName',
                    title: 'user.first-name'},
                { key: 'lastName',
                    title: 'user.last-name'},
                { key: 'authority',
                    title: 'user.role',
                    cellContentFunction: (value) => {
                        return $translate.instant(types.authority[value].name);
                    }
                }

            ],

            addEntityTemplateUrl: addUserTemplate,
            addEntityController: 'AddUserController',

            loadEntities: () => {return getUsers(scope, currentUser, params)},
            loadEntity: (entityId) => {return userService.getUser(entityId)},
            saveEntity: (entity) => {return userService.saveUser(entity)},
            deleteEntity: (entityId) => {return userService.deleteUser(entityId)},

            displayActivationLink: (event, entity) => {
                displayActivationLink(event, entity);
            },

            resendActivation: (event, entity) => {
                resendActivation(event, entity);
            },

            actionCellDescriptors: [
            {
                name: 'user.display-activation-link',
                icon: 'link',
                isEnabled: (entity) => {
                    return access == types.access.admin && entity && entity.id && currentUser.userId != entity.id.id;
                },
                onAction: ($event, entity) => {
                    displayActivationLink($event, entity);
                }
            },
            {
                name: 'user.resend-activation',
                icon: 'send',
                isEnabled: (entity) => {
                    return access == types.access.admin && entity && entity.id && currentUser.userId != entity.id.id;
                },
                onAction: ($event, entity) => {
                    resendActivation($event, entity);
                }
            }],

            detailsReadOnly: (entity) => {
                return access == types.access.user || entity && entity.id && currentUser.userId == entity.id.id;
            },

            addEnabled: () => {
                return access == types.access.admin;
            },

            deleteEnabled: (entity) => {
                return access == types.access.admin && entity && entity.id && currentUser.userId != entity.id.id;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('user.delete-user-title', {userEmail: entity.email});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('user.delete-user-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('user.delete-users-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('user.delete-users-text');
            }

        };
        if (scope == types.scope.system) {
            tableConfiguration.columns.push(
                {
                    key: 'providerTitle',
                    title: 'provider.provider'
                }
            );
        } else if (scope == types.scope.provider && !params.providerId) {
            tableConfiguration.columns.push(
                {
                    key: 'customerTitle',
                    title: 'customer.customer'
                }
            );
        } else if (scope == types.scope.customer && !params.customerId) {
            tableConfiguration.columns.push(
                {
                    key: 'subCustomerTitle',
                    title: 'subCustomer.subCustomer'
                }
            );
        }

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function getTitle(scope, entityTitle) {
        var title;
        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + $translate.instant('user.users');
        } else {
            title = $translate.instant('user.users');
        }
        return title;
    }

    function getUsers(scope, user, params) {
        switch(scope) {
            case types.scope.system:
                return userService.getSystemAndProviderUsers();
            case types.scope.provider:
                if (params.providerId) {
                    return userService.getProviderUsers(params.providerId);
                } else {
                    return userService.getProviderAndCustomerUsers();
                }
            case types.scope.customer:
                if (params.customerId) {
                    return userService.getCustomerUsers(params.customerId);
                } else {
                    return userService.getCustomerAndSubCustomerUsers();
                }
            case types.scope.subCustomer:
                if (params.subCustomerId) {
                    return userService.getSubCustomerUsers(params.subCustomerId);
                } else {
                    return userService.getCurrentSubCustomerUsers();
                }
        }
    }

    function displayActivationLink(event, entity) {
        if (event) {
            event.stopPropagation();
        }
        userService.getActivationLink(entity.id.id).then(
            function success(activationLink) {
                openActivationLinkDialog(event, activationLink);
            }
        );
    }

    function resendActivation(event, entity) {
        if (event) {
            event.stopPropagation();
        }
        userService.sendActivationEmail(entity.email).then(function success() {
            toast.showSuccess($translate.instant('user.activation-email-sent-message'));
        });
    }

    function openActivationLinkDialog(event, activationLink) {
        $mdDialog.show({
            controller: 'ActivationLinkDialogController',
            controllerAs: 'vm',
            templateUrl: activationLinkDialogTemplate,
            locals: {
                activationLink: activationLink
            },
            parent: angular.element($document[0].body),
            fullscreen: true,
            skipHide: true,
            targetEvent: event
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/user/user-table.config.js